import { create } from "zustand";
import { ToastType } from "../constants/toast";


type Toast = {
  content: string,
  type: ToastType
}

type ToastifyStore = {
  toast: Toast,
  addToast: (toast: Toast) => void,
  deleteToast: () => void,
}

const initialToast = {
  content: "",
  type: ToastType.default
}

export const useToastifyStore = create<ToastifyStore>((set, get) => ({
  toast: initialToast,
  addToast: (toast: Toast) => set({ toast }),
  deleteToast: () => set({ toast: initialToast })

}))



export const addToastGlobal = (toast: Toast) => {
  useToastifyStore.getState().addToast(toast);
};